let _initProto, _initClass, _init_label, _init_extra_label, _init_value, _init_extra_value, _init_changeEvent, _init_extra_changeEvent;
function _applyDecs(e, t, n, r, o, i) { var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length; function g(t, n, r) { return function (o, i) { n && (i = o, o = e); for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []); return r ? i : o; }; } function b(e, t, n, r) { if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined")); return e; } function applyDec(e, t, n, r, o, i, u, s, f, l, p) { function d(e) { if (!p(e)) throw new TypeError("Attempted to access private element on non-instance"); } var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o; function I(t, n, r) { return function (o, i) { return n && (i = o, o = e), r && r(o), P[t].call(o, i); }; } if (!w) { var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value"; if (f ? (l || D ? P = { get: _setFunctionName(function () { return v(this); }, r, "get"), set: function (e) { t[4](this, e); } } : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) { if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet"); y[+s][r] = o < 3 ? 1 : o; } } for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) { var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = { kind: ["field", "accessor", "method", "getter", "setter", "class"][o], name: r, metadata: a, addInitializer: function (e, t) { if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished"); b(t, "An initializer", "be", !0), i.push(t); }.bind(null, A) }; if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function (e) { return r in e; } }, j || (c.get = f ? E ? function (e) { return d(e), P.value; } : I("get", 0, d) : function (e) { return e[r]; }), E || S || (c.set = f ? I("set", 0, d) : function (e, t) { e[r] = t; }), N = T.call(z, D ? { get: P.get, set: P.set } : P[F], H), A.v = 1, D) { if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined"); } else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N); } return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N; } function w(e) { return m(e, d, { configurable: !0, enumerable: !0, value: a }); } return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function (e) { e && f.push(g(e)); }, p = function (t, r) { for (var i = 0; i < n.length; i++) { var a = n[i], c = a[1], l = 7 & c; if ((8 & c) == t && !l == r) { var p = a[2], d = !!a[3], m = 16 & c; applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function (t) { return _checkInRHS(t) === e; } : o); } } }, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), { e: c, get c() { var n = []; return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)]; } }; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _setFunctionName(e, t, n) { "symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : ""); try { Object.defineProperty(e, "name", { configurable: !0, value: n ? n + " " + t : t }); } catch (e) {} return e; }
function _checkInRHS(e) { if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null")); return e; }
import { RadiantElement, customElement, event, onEvent, onUpdated, prop } from "@ecopages/radiant";
import { applyRovingTabindex, focusRovingItem } from "@/lib/roving-tabindex";
let _RuiTreegrid;
class RuiTreegrid extends RadiantElement {
  static {
    ({
      e: [_init_label, _init_extra_label, _init_value, _init_extra_value, _init_changeEvent, _init_extra_changeEvent, _initProto],
      c: [_RuiTreegrid, _initClass]
    } = _applyDecs(this, [customElement("rui-treegrid")], [[prop({
      type: String,
      defaultValue: ""
    }), 0, "label"], [prop({
      type: String,
      reflect: true,
      defaultValue: ""
    }), 0, "value"], [event({
      name: "rui-change",
      bubbles: true,
      composed: true
    }), 0, "changeEvent"], [onUpdated("value"), 2, "onValueUpdated"], [onEvent({
      selector: '[role="gridcell"]',
      type: "click"
    }), 2, "onCellClick"], [onEvent({
      selector: '[role="gridcell"]',
      type: "keydown"
    }), 2, "onCellKeydown"]], 0, void 0, RadiantElement));
  }
  constructor(...args) {
    super(...args);
    _init_extra_changeEvent(this);
  }
  label = (_initProto(this), _init_label(this));
  value = (_init_extra_label(this), _init_value(this));
  changeEvent = (_init_extra_value(this), _init_changeEvent(this));
  getDataRows() {
    return Array.from(this.querySelectorAll('[role="row"][data-row-id]'));
  }
  getVisibleRows() {
    return this.getDataRows().filter(row => {
      let parent = row.parentElement;
      while (parent && parent !== this) {
        if (parent.getAttribute("role") === "rowgroup" && parent.hidden) {
          return false;
        }
        parent = parent.parentElement;
      }
      return true;
    });
  }
  getRowCells(row) {
    return Array.from(row.children).filter(child => child instanceof HTMLElement && child.getAttribute("role") === "gridcell");
  }
  getVisibleCells() {
    return this.getVisibleRows().flatMap(row => this.getRowCells(row));
  }
  getParentRow(row) {
    const group = row.parentElement;
    if (!group || group.getAttribute("role") !== "rowgroup") {
      return null;
    }
    const parent = group.previousElementSibling;
    return parent?.getAttribute("role") === "row" ? parent : null;
  }
  syncExpanded() {
    for (const row of this.getDataRows()) {
      if (!row.hasAttribute("aria-expanded")) {
        continue;
      }
      const group = row.nextElementSibling;
      if (group?.getAttribute("role") === "rowgroup") {
        group.hidden = row.getAttribute("aria-expanded") === "false";
      }
    }
  }
  syncSelection() {
    const cells = this.getVisibleCells();
    let activeIndex = 0;
    for (const row of this.getDataRows()) {
      const rowId = row.getAttribute("data-row-id") ?? "";
      const selected = Boolean(this.value) && rowId === this.value;
      for (const cell of this.getRowCells(row)) {
        cell.setAttribute("aria-selected", String(selected));
        if (selected) {
          const index = cells.indexOf(cell);
          if (index >= 0) {
            activeIndex = index;
          }
        }
      }
    }
    if (cells.length > 0) {
      applyRovingTabindex(cells, activeIndex);
    }
  }
  onConnected() {
    this.syncExpanded();
    this.syncSelection();
  }
  onValueUpdated() {
    this.syncSelection();
  }
  setExpanded(row, expanded) {
    row.setAttribute("aria-expanded", String(expanded));
    const group = row.nextElementSibling;
    if (group?.getAttribute("role") === "rowgroup") {
      group.hidden = !expanded;
    }
  }
  activateCell(cell) {
    const row = cell.closest('[role="row"][data-row-id]');
    if (!row) {
      return;
    }
    const rowId = row.getAttribute("data-row-id") ?? "";
    const columnIndex = this.getRowCells(row).indexOf(cell);
    this.value = rowId;
    this.syncSelection();
    this.changeEvent.emit({
      rowId,
      columnIndex
    });
    cell.focus();
  }
  focusCell(row, columnIndex) {
    const rows = this.getVisibleRows();
    const rowIndex = rows.indexOf(row);
    if (rowIndex < 0) {
      return;
    }
    const cells = this.getVisibleCells();
    const rowCells = this.getRowCells(row);
    const target = rowCells[Math.min(Math.max(0, columnIndex), rowCells.length - 1)];
    const nextIndex = cells.indexOf(target);
    if (nextIndex >= 0) {
      focusRovingItem(cells, nextIndex);
    }
  }
  onCellClick(event2) {
    const cell = event2.target.closest('[role="gridcell"]');
    if (!cell || !this.contains(cell)) {
      return;
    }
    const row = cell.closest('[role="row"][data-row-id]');
    if (row) {
      const isFirstCell = this.getRowCells(row).indexOf(cell) === 0;
      if (isFirstCell && row.hasAttribute("aria-expanded")) {
        this.setExpanded(row, row.getAttribute("aria-expanded") !== "true");
      }
    }
    this.activateCell(cell);
  }
  onCellKeydown(event2) {
    const cell = event2.target.closest('[role="gridcell"]');
    const row = cell?.closest('[role="row"][data-row-id]');
    if (!cell || !row) {
      return;
    }
    const visibleRows = this.getVisibleRows();
    const rowIndex = visibleRows.indexOf(row);
    const rowCells = this.getRowCells(row);
    const colIndex = rowCells.indexOf(cell);
    const isFirstCell = colIndex === 0;
    const isExpandable = row.hasAttribute("aria-expanded");
    const isExpanded = row.getAttribute("aria-expanded") === "true";
    switch (event2.key) {
      case "ArrowRight":
        {
          event2.preventDefault();
          if (isFirstCell && isExpandable && !isExpanded) {
            this.setExpanded(row, true);
            this.syncSelection();
            return;
          }
          if (colIndex < rowCells.length - 1) {
            this.focusCell(row, colIndex + 1);
          }
          return;
        }
      case "ArrowLeft":
        {
          event2.preventDefault();
          if (isFirstCell && isExpandable && isExpanded) {
            this.setExpanded(row, false);
            this.syncSelection();
            return;
          }
          if (colIndex > 0) {
            this.focusCell(row, colIndex - 1);
            return;
          }
          const parent = this.getParentRow(row);
          if (parent) {
            this.focusCell(parent, 0);
          }
          return;
        }
      case "ArrowDown":
        {
          event2.preventDefault();
          const nextRow = visibleRows[Math.min(visibleRows.length - 1, rowIndex + 1)];
          if (nextRow && nextRow !== row) {
            this.focusCell(nextRow, colIndex);
          }
          return;
        }
      case "ArrowUp":
        {
          event2.preventDefault();
          const prevRow = visibleRows[Math.max(0, rowIndex - 1)];
          if (prevRow && prevRow !== row) {
            this.focusCell(prevRow, colIndex);
          }
          return;
        }
      case "Home":
        {
          event2.preventDefault();
          this.focusCell(row, 0);
          return;
        }
      case "End":
        {
          event2.preventDefault();
          this.focusCell(row, rowCells.length - 1);
          return;
        }
      case "*":
        {
          event2.preventDefault();
          for (const sibling of this.getDataRows()) {
            if (sibling.hasAttribute("aria-expanded")) {
              this.setExpanded(sibling, true);
            }
          }
          this.syncSelection();
          return;
        }
      case "Enter":
        {
          event2.preventDefault();
          if (isFirstCell && isExpandable) {
            this.setExpanded(row, !isExpanded);
            this.syncSelection();
            return;
          }
          this.activateCell(cell);
          return;
        }
      case " ":
        {
          event2.preventDefault();
          this.activateCell(cell);
          return;
        }
      default:
        return;
    }
  }
  static {
    _initClass();
  }
}
export { _RuiTreegrid as RuiTreegrid };